import { NavLink } from "react-router-dom";
import { Mail, Linkedin } from "lucide-react";
import { cn } from "@/lib/utils";
import { track } from "@/lib/analytics";

const tabs = [
  {
    to: "/",
    label: "Outreach Generator",
    shortLabel: "Outreach",
    icon: Mail,
    slug: "outreach_generator",
  },
  {
    to: "/find-creators",
    label: "Find LinkedIn Creators",
    shortLabel: "LinkedIn Creators",
    icon: Linkedin,
    slug: "find_creators",
  },
] as const;

export const ToolTabs = () => {
  return (
    <div className="max-w-2xl mx-auto px-5 sm:px-8 flex justify-center">
      <nav
        aria-label="Tools"
        className="inline-flex w-full sm:w-auto items-stretch justify-center gap-1 p-1 rounded-full border border-brand-border bg-white shadow-sm"
      >
        {tabs.map(({ to, label, shortLabel, icon: Icon, slug }) => (
          <NavLink
            key={to}
            to={to}
            end
            onClick={() => track("outreach_tool_tab_switched", { tab: slug })}
            className={({ isActive }) =>
              cn(
                "flex-1 sm:flex-none inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors",
                isActive
                  ? "bg-brand-blue text-white shadow-sm"
                  : "text-brand-navy/80 hover:text-brand-navy hover:bg-brand-bg",
              )
            }
          >
            <Icon className="h-4 w-4 shrink-0" />
            <span className="sm:hidden">{shortLabel}</span>
            <span className="hidden sm:inline">{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default ToolTabs;
